import { useCallback, useSyncExternalStore } from 'react';

/*
 * ТЗ V5 №2: тема портала. Выбор хранится в этом браузере; повреждённое
 * значение или недоступное хранилище — светлая тема, без аварии. Тот же ключ
 * читает скрипт в public/index.html до первого рендера, чтобы не было вспышки.
 */
export const THEME_STORAGE_KEY = 'portal_theme';
export const THEMES = { LIGHT: 'light', DARK: 'dark' };
const THEME_EVENT = 'theme-change';

export const readStoredTheme = () => {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
  } catch {
    return THEMES.LIGHT;
  }
};

export const getCurrentTheme = () => (
  document.documentElement.getAttribute('data-bs-theme') === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT
);

export const applyTheme = (theme) => {
  const next = theme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
  document.documentElement.setAttribute('data-bs-theme', next);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, next);
  } catch {
    // Без хранилища тема действует до перезагрузки.
  }
  window.dispatchEvent(new Event(THEME_EVENT));
};

const subscribe = (callback) => {
  const onStorage = (event) => {
    if (event.key !== THEME_STORAGE_KEY) return;
    document.documentElement.setAttribute('data-bs-theme', readStoredTheme());
    callback();
  };
  window.addEventListener(THEME_EVENT, callback);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(THEME_EVENT, callback);
    window.removeEventListener('storage', onStorage);
  };
};

/** Текущая тема и переключатель. Смена темы не трогает маршрут и данные. */
export const useTheme = () => {
  const theme = useSyncExternalStore(subscribe, getCurrentTheme, () => THEMES.LIGHT);
  const toggle = useCallback(() => {
    applyTheme(getCurrentTheme() === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK);
  }, []);
  return { theme, toggle };
};
